import "./style.scss";
import { Controller, Control } from "react-hook-form";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useEffect, useState } from "react";

interface PhoneInputControllerProps {
  name: string;
  control: Control<any>;
  rules?: object;
  placeholder?: string;
  className?: string;
  onFocus?: () => void;
}

export const PhoneInputController = ({
  name,
  control,
  rules,
  placeholder = "Телефон:",
  className = "",
  onFocus,
}: PhoneInputControllerProps) => {
  const [userCountry, setUserCountry] = useState<string>("ua");

  useEffect(() => {
    fetch("https://ipapi.co/json/")
      .then((res) => res.json())
      .then((data) => {
        if (data && data.country_code) {
          setUserCountry(data.country_code.toLowerCase());
        }
      })
      .catch((err) => {
        setUserCountry("ua");
      });
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({ field, fieldState }) => (
        <div className={`phone-input-wrapper ${className}`}>
          <PhoneInput
            country={userCountry}
            value={field.value}
            onChange={field.onChange}
            inputProps={{
              name,
              required: true,
              onFocus: onFocus,
            }}
            specialLabel=""
            placeholder={placeholder}
            inputClass="custom-phone-input"
          />
        </div>
      )}
    />
  );
};
